var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateNewProgramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_352",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 33.5313C16.3664 33.5313 13.3032 32.6497 10.6977 30.998C8.0922 29.3464 6.06147 26.9988 4.86229 24.2522C3.66311 21.5056 3.34936 18.4833 3.96069 15.5676C4.57203 12.6518 6.081 9.97347 8.29678 7.87131C10.5126 5.76915 13.3357 4.33756 16.409 3.75758C19.4824 3.17759 22.6681 3.47526 25.5631 4.61294C28.4582 5.75062 30.9327 7.67722 32.6736 10.1491C34.4145 12.621 35.3438 15.5271 35.3438 18.5C35.3438 22.4865 33.6745 26.3098 30.7032 29.1287C27.732 31.9476 23.702 33.5313 19.5 33.5313ZM19.5 5.78126C16.8485 5.78126 14.2565 6.5272 12.0519 7.92475C9.84725 9.32231 8.12893 11.3087 7.11425 13.6328C6.09956 15.9568 5.83407 18.5141 6.35135 20.9813C6.86864 23.4485 8.14546 25.7148 10.0204 27.4935C11.8953 29.2723 14.284 30.4836 16.8846 30.9744C19.4851 31.4651 22.1807 31.2133 24.6304 30.2506C27.08 29.2879 29.1738 27.6578 30.6469 25.5662C32.12 23.4746 32.9063 21.0155 32.9063 18.5C32.9063 15.1268 31.4938 11.8917 28.9797 9.50649C26.4655 7.12126 23.0556 5.78126 19.5 5.78126Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 26.5938C19.1768 26.5938 18.8668 26.4719 18.6382 26.2551C18.4097 26.0383 18.2812 25.7442 18.2812 25.4375V11.5625C18.2812 11.2558 18.4097 10.9617 18.6382 10.7449C18.8668 10.5281 19.1768 10.4062 19.5 10.4062C19.8232 10.4062 20.1332 10.5281 20.3618 10.7449C20.5903 10.9617 20.7188 11.2558 20.7188 11.5625V25.4375C20.7188 25.7442 20.5903 26.0383 20.3618 26.2551C20.1332 26.4719 19.8232 26.5938 19.5 26.5938Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8125 19.6562H12.1875C11.8643 19.6562 11.5543 19.5344 11.3257 19.3176C11.0972 19.1008 10.9688 18.8067 10.9688 18.5C10.9688 18.1933 11.0972 17.8992 11.3257 17.6824C11.5543 17.4656 11.8643 17.3438 12.1875 17.3438H26.8125C27.1357 17.3438 27.4457 17.4656 27.6743 17.6824C27.9028 17.8992 28.0312 18.1933 28.0312 18.5C28.0312 18.8067 27.9028 19.1008 27.6743 19.3176C27.4457 19.5344 27.1357 19.6562 26.8125 19.6562Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_352)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.21619,
    y: -10,
    width: 51.6486,
    height: 58,
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateNewProgramIcon);
export default __webpack_public_path__ + "static/media/createNewProgramIcon.340e6313d5780db032ec6eca2cb11d9d.svg";
export { ForwardRef as ReactComponent };